/**
 * Figma → website scale tokens.
 * Use these instead of raw Figma pixel values in components.
 */
export const scale = {
  fontSize: {
    /** Figma 100px */
    display: 80,
    /** Figma 64px — section headings */
    sectionTitle: 48,
    /** Figma 36px — body lead / subtitles at desktop */
    lead: 30,
    /** Figma 34px */
    subheading: 28,
    /** Figma 26px — small headings / labels */
    label: 22,
    /** Figma 84px — stats display numbers */
    statDisplay: 67,
    /** Figma 44px — stats labels */
    statLabel: 35,
  },
  gap: {
    /** Figma 100px — large section / card internal gaps */
    xl: 50,
  },
  size: {
    /** Figma 80px — icon frames, avatars, touch targets */
    lg: 64,
    /** Figma 48px icon inside 80px frame */
    iconInner: 38,
  },
}

/** Responsive section title scale (Figma 64px desktop → 48px) */
export const sectionTitleFontSize = {
  xs: 40,
  sm: 48,
  md: 56,
  lg: scale.fontSize.sectionTitle,
}

/** Hero display scale (Figma 100px desktop → 80px) */
export const heroDisplayFontSize = {
  xs: 44,
  sm: 56,
  md: 72,
  lg: scale.fontSize.display,
}

/** Lead copy at desktop (Figma 36px → 30px) */
export const leadFontSize = {
  xs: 18,
  sm: 24,
  md: 30,
  lg: scale.fontSize.lead,
}

/** Small section label (Figma 26px → 22px) */
export const labelFontSize = {
  xs: 22,
  md: scale.fontSize.label,
}

export default scale
